import React from 'react'

function Footer() {
  return (
    <div className="footer text-center p-3 bg-dark text-white">
      Made with ❤️ by Vincent Raja
    </div>
  )
}

export default Footer